import React from 'react';
import withStyles from '@mui/styles/withStyles';
import { Button, Checkbox, FormControlLabel, Grid, Typography } from '@mui/material';
import AbEnvironment from '../auth/AbEnvironment';
import AchConfirmUpdateMutation from '../account/AchConfirmUpdateMutation';
import { formatISO } from 'date-fns';
import SavingSpinner from '../ui/SavingSpinner';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
  },
  flex: {
    flex: 1,
  }
});

class ACHFormIIAccept extends React.Component {

  state = {
    accountId:        this.props.dAccountId,
    firstName:        this.props.dFirstName,
    lastName:         this.props.dLastName,
    email:            this.props.dEmail,
    phone:            this.props.dPhone,
    address1:         this.props.dAddress1,
    address2:         this.props.dAddress2,
    city:             this.props.dCity,
    state:            this.props.dState,
    country:          this.props.dCountry,
    pcId:             this.props.pcId,
    achCDate:         abEnvironment.getUserAttribute('a_achCDate'),
    accepted:         false,
    clickedAccepted:  false
  }

  handleCancel() {
    this.props.onClose();
  }

  acceptClicked() {
//console.log('acceptccept clicked');
    this.setState({clickedAccepted: true});
    let nowdate = formatISO(new Date());

    Promise.resolve()
    .then(() => {
      let acctId = this.props.dAccountId;

      // update the account to have an ach accept date
      return AchConfirmUpdateMutation.commit(acctId, nowdate);
    })  
    .then(aresp => {
      // callDwolla 
      this.createDwollaCustomer(nowdate);
    })
    .catch(err => {
      window.location.reload();
    });
  }

  createDwollaCustomer(nowdate) {
//console.log('calling dwolla create customer');
    const { callPartnerApi } = this.props.auth;
    let history = this.props.history;
    //let thisPage = this; 

    let pcId            = this.state.pcId;
    let acctId          = this.props.dAccountId;
    let fname           = this.props.dFirstName;
    let lname           = this.props.dLastName;
    let email           = this.props.dEmail;

    let success      = false;

    let dcid;  // For sharing in chains

    let aPjwt = abEnvironment.getPjwt();

    // Call server side ach form prep
    let payload = {
      operation: "createDwollaCustomer",
      params: {
        pJwt:      aPjwt,
        accountId: acctId,
        dcId:      pcId,
        firstName: fname,
        lastName:  lname,
        email:     email
      }
    };

    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    ).then(resp => {
      return resp.json();
    }).then(data => {
      if (pcId == null) {
        // Should have a pcId now...
        dcid = data.dcId;
        if (dcid) {
          // If this is the own user's account, need to set the dwolla id on
          // the env uinfo.
          if (acctId === abEnvironment.getUserAttribute('a_id')) {
            abEnvironment.setUserAttribute("a_dwollaCid", dcid);
          }
          // set the date on the abEnvironment
          abEnvironment.setUserAttribute('a_achCDate', nowdate);
          this.props.setDwollaCid(dcid, nowdate);

        }
      }


    }).catch(reason => {
      // console.log('Failure in iav setup: ' + reason);
    });      
  }

  render() {
    const classes = this.props.classes;

      return (
        <div style={{height: 800}}>
          <Grid container spacing={3} direction="row"  style={{paddingTop: '16px'}}>
            <Grid item xs={12}>
              <Typography variant="subtitle1" style={{marginTop:'24px'}}>
                  We use a trusted platform, Dwolla, to facilitate ACH transfers between you and AppBind.
                  By adding an ACH payment source, you're authorizing AppBind to automatically transfer funds
                  from your bank account to pay for subscriptions purchased with AppBind.
              </Typography>
            </Grid>           
            <Grid item xs={12}>
              <FormControlLabel
                control={<Checkbox
                  checked={this.state.accepted}
                  value="accepted"
                  onChange={ (e) => this.setState({ accepted: e.target.checked }) }
                />}
                label={
                  <div>
                    <span>I accept the Dwolla </span>
                    <a target="_blank" rel="noopener noreferrer" href="https://www.dwolla.com/legal/tos/">Terms of Service</a>
                    <span> and </span>
                    <a target="_blank" rel="noopener noreferrer" href="https://www.dwolla.com/legal/privacy/">Privacy Policy</a>
                  </div>}
              />
            </Grid>
            
            <Grid item xs={12} align="center">
                {!this.state.clickedAccepted &&
                <Button color="primary" variant="contained" disabled={!this.state.accepted} onClick={() => {this.acceptClicked()}}  className={classes.button} >Continue</Button>
                }
                {this.state.clickedAccepted &&
                <Button color="primary" variant="outlined" >
                  <SavingSpinner/> 
                </Button>
                }
                &nbsp;&nbsp;&nbsp;
                <Button color="primary" variant="outlined"  onClick={() => {this.handleCancel()}}  className={classes.button} >Cancel</Button>
            </Grid>
          </Grid>
        </div>
      );

  }
}

export default withStyles(styleSheet)(ACHFormIIAccept);